import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/trigger_play.png'


const _withScopeId = n => (_pushScopeId("data-v-46ccff39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat_conent_bg" }
const _hoisted_2 = { class: "message_container_bg" }
const _hoisted_3 = { class: "title_name" }
const _hoisted_4 = {
  key: 0,
  class: "chat-content"
}
const _hoisted_5 = { class: "message_content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "trigger_chat_content"
}
const _hoisted_8 = {
  key: 0,
  class: "play_icon_bg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "trigger_play_icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isUmi ? 'identity_view_umi' : 'identity_view_mine'])
    }, null, 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.isUmi ? _ctx.npcName : "YOU"), 1),
      (_ctx.triggerType == -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                ref: "mathjaxRef",
                innerHTML: _ctx.text ? _ctx.text : ''
              }, null, 8, _hoisted_6)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.triggerType == 2 || _ctx.triggerType == 4)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({
            width: _ctx.imgWidth + 'rem',
            height: _ctx.imgHeight + 'rem',
            backgroundImage: 'url(' + _ctx.thumbnailImg + ')',
          }),
                  class: "trigger_chat_img",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickImg && _ctx.clickImg(...args)))
                }, null, 4))
              : (_ctx.triggerType == 3 || _ctx.triggerType == 5)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "trigger_chat_video",
                    style: _normalizeStyle({
            width: _ctx.imgWidth + 'rem',
            height: _ctx.imgHeight + 'rem',
            backgroundImage: 'url(' + _ctx.thumbnailImg + ')',
          }),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickVideo && _ctx.clickVideo(...args)))
                  }, [
                    (_ctx.triggerType == 3 || _ctx.triggerType == 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ], 4))
                : _createCommentVNode("", true)
          ]))
    ])
  ]))
}